'use client'
import { useState, useEffect } from 'react'
import { Listbox } from "@headlessui/react"
import { useRouter, useSearchParams } from 'next/navigation'
import { getSearchParams, removeSearchParam, updateDistrictParams } from "@utils";
import { RiArrowDropDownLine } from 'react-icons/ri'
import tailwindConfig from '@tailwind.config'

const DistrictFilter = ({ title, districtList, dictionary }) => {
    const router = useRouter();
    const searchParams = useSearchParams();

    const [query, setQuery] = useState('')
    const [selectedDistrict, setSelectedDistrict] = useState(districtList[0])

    const handleUpdateParams = (e) => {
        setSelectedDistrict(e)
        let newPathName
        if (e.value === '1') {
            newPathName = removeSearchParam(title);
        } else {
            newPathName = updateDistrictParams(e.id)
        }

        // Use router.replace() to update the URL without adding to history.
        router.replace(newPathName);

        // This is the line that caused the lag. It's now removed.
        // router.refresh();
    };

    // Initialize state directly from the URL, removing the need for a useEffect hook that re-runs.
    useEffect(() => {
        const districtValue = getSearchParams('district');
        const newValue = districtList.find(obj => obj.id === districtValue);

        if (newValue) {
            setSelectedDistrict(newValue);
        } else {
            setSelectedDistrict(districtList[0]);
        }
    }, [districtList, title]); // Cleaned up dependencies

    const filteredDistrict =
        query === ''
            ? districtList
            : districtList.filter((item) => (
                item.subdistrict.toLowerCase().replace(/\s+/g, '').includes(query.toLocaleLowerCase().replace(/\s+/g, ''))
            ))

    return (
        <div className='flex flex-col mt-2'>
            <span className='text-xl text-secondary mb-1'>{dictionary.area}:</span>
            <Listbox value={selectedDistrict} onChange={(value) => { handleUpdateParams(value) }}>
                <div className="relative w-full">
                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg shadow-md bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                        <Listbox.Button className='w-full border-none py-2 pl-3 pr-10 text-sm flex items-center leading-5 text-gray-900 focus:ring-0'>
                            {selectedDistrict.subdistrict}
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2">
                                <RiArrowDropDownLine
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                    size={28}
                                />
                            </span>
                        </Listbox.Button>
                    </div>
                    <Listbox.Options
                        className='z-50 left-0 right-0 absolute bg-white h-auto max-h-[200px] overflow-y-auto shadow-md rounded-md py-1'
                    >
                        {filteredDistrict.map((district) => (
                            <Listbox.Option
                                key={district.id}
                                value={district}
                                className='py-2 px-4 cursor-pointer color-secondary z-50 flex flex-row items-center'
                            >
                                <span className="ml-2 text-maincolor">{district.subdistrict}</span>
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </div>
            </Listbox>
        </div >
    )
}

export default DistrictFilter

// 'use client'
// import { useState, useEffect } from 'react'
// import { Listbox } from "@headlessui/react"
// import { useRouter } from 'next/navigation'
// import { getSearchParams, removeSearchParam, updateDistrictParams } from "@utils";
// import { RiArrowDropDownLine } from 'react-icons/ri'
// import tailwindConfig from '@tailwind.config'




// const DistrictFilter = ({ title, districtList, dictionary }) => {
//     const router = useRouter();

//     const [query, setQuery] = useState('')
//     const [selectedDistrict, setSelectedDistrict] = useState(districtList[0])


//     const handleUpdateParams = (e) => {

//         setSelectedDistrict(e)
//         // const newPathName = updateSearchParams(title, e.value);
//         let newPathName
//         if (e.value == '1') {
//             newPathName = removeSearchParam(title);
//         } else {
//             // newPathName = updateSearchParams(title, e.id);
//             newPathName = updateDistrictParams(e.id)

//         }

//         router.push(newPathName);

//         router.refresh()
//     };

//     useEffect(() => {
//         const districtValue = getSearchParams('district')
//         const newValue = districtList.find(obj => obj.id === districtValue);
//         // console.log('new value ' + newValue)
//         if (newValue != undefined) {
//             setSelectedDistrict(newValue)
//         } else {
//             // if (maxPriceValue === null) {
//             setSelectedDistrict(districtList[0])
//             // } else {
//             //     setSelectedBts({ value: btsValue, nom: priceFormatter(btsValue) })
//             // }
//         }

//     }, [handleUpdateParams])

//     const filteredDistrict =
//         query === ''
//             ? districtList
//             : districtList.filter((item) => (
//                 item.subdistrict.toLowerCase().replace(/\s+/g, '').includes(query.toLocaleLowerCase().replace(/\s+/g, '')
//                 )))


//     return (
//         <div className='flex flex-col mt-2'>
//             <span className='text-xl text-secondary mb-1'>{dictionary.area}:</span>
//             <Listbox value={selectedDistrict} onChange={(value) => { handleUpdateParams(value) }}>
//                 <div className="relative w-full">
//                     <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg shadow-md bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
//                         <Listbox.Button className='w-full border-none py-2 pl-3 pr-10 text-sm flex items-center leading-5 text-gray-900 focus:ring-0'>
//                             {/* <Image
//                                 src="/images/icons/bts.png"
//                                 width={20}
//                                 height={20}
//                                 className="ml-4"
//                                 alt="BTS icon"
//                             /> */}
//                             {selectedDistrict.subdistrict}
//                             <span className="absolute inset-y-0 right-0 flex items-center pr-2">
//                                 <RiArrowDropDownLine
//                                     color={tailwindConfig.theme.extend.colors.secondary}
//                                     size={28}
//                                 />
//                             </span>
//                         </Listbox.Button>
//                     </div>
//                     <Listbox.Options

//                         // as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
//                         className='z-50 left-0 right-0 absolute bg-white h-auto max-h-[200px] overflow-y-auto shadow-md rounded-md py-1'
//                     >
//                         {filteredDistrict.map((district) => (
//                             <Listbox.Option
//                                 key={district.id}
//                                 value={district}
//                                 className='py-2 px-4 cursor-pointer color-secondary z-50 flex flex-row items-center'
//                             >
//                                 <span className="ml-2 text-maincolor">{district.subdistrict}</span>
//                             </Listbox.Option>
//                         ))}
//                     </Listbox.Options>
//                 </div>
//             </Listbox>
//         </div >
//     )
// }

// export default DistrictFilter